import i18n from './i18n';

export default {
  get() {
    return i18n.language;
  },
};
